import { ProjectModel } from "../../types";

export interface ProjectDropdownItemArgs {
  type: ProjectDropdownItems;
  project: ProjectModel;
}

export enum ProjectDropdownItems {
  Duplicate,
  Delete,
}
